import { DecorItemI } from "../../shared";
import { Group, Vector3 } from "three";

function calcRelativePaddings(
    decor: DecorItemI,
    roomSizes: {
        roomLength: number;
        roomHeight: number;
        roomDepth: number;
    },
    bBoxDecorSize?: Vector3
) {
    const boundingZ = bBoxDecorSize?.z ?? decor.depth;
    const boundingY = bBoxDecorSize?.y ?? decor.height;
    const boundingX = bBoxDecorSize?.x ?? decor.width;

    let left = 0;
    let right = 0;
    const side = decor.side;
    if (side === "left") {
        left = roomSizes.roomDepth - (decor.position[2] + boundingX * decor.center[0]) * 1000;
        right = (decor.position[2] - boundingX * decor.center[0]) * 1000;
    }

    if (side === "right") {
        right = roomSizes.roomDepth - (decor.position[2] + boundingX * decor.center[0]) * 1000;
        left = (decor.position[2] - boundingX * decor.center[0]) * 1000;
    }

    if (side === "front") {
        left = -(roomSizes.roomLength / 2) - (decor.position[0] - boundingX * decor.center[0]) * 1000;
        right = roomSizes.roomLength / 2 - (decor.position[0] + boundingX * decor.center[0]) * 1000;
    }

    if (side === "back") {
        right = -roomSizes.roomLength / 2 - (decor.position[0] - boundingX * decor.center[0]) * 1000;
        left = roomSizes.roomLength / 2 - (decor.position[0] + boundingX * decor.center[0]) * 1000;
    }

    let top = roomSizes.roomHeight - (decor.position[1] + boundingY * decor.center[1]) * 1000;
    let bottom = (decor.position[1] - boundingY * decor.center[1]) * 1000;

    if (["floor", "ceiling"].includes(decor.surface)) {
        // top = (decor.position[2] - boundingZ * decor.center[0]) * 1000;
        // bottom = roomSizes.roomDepth - (decor.position[2] + boundingZ * decor.center[0]) * 1000;
        top = roomSizes.roomDepth - (decor.position[2] + boundingZ * decor.center[0]) * 1000;
        bottom = (decor.position[2] - boundingZ * decor.center[0]) * 1000;
    }
    if (["floor", "ceiling"].includes(decor.surface)) {
        if (side === "left") {
            left = -(roomSizes.roomLength / 2) - (decor.position[0] - boundingX * decor.center[0]) * 1000;
            right = roomSizes.roomLength / 2 - (decor.position[0] + boundingX * decor.center[0]) * 1000;
        }

        if (side === "right") {
            left = -(roomSizes.roomLength / 2) - (decor.position[0] - boundingX * decor.center[0]) * 1000;
            right = roomSizes.roomLength / 2 - (decor.position[0] + boundingX * decor.center[0]) * 1000;
        }
        if (side === "back") {
            left = -roomSizes.roomLength / 2 - (decor.position[0] - boundingX * decor.center[0]) * 1000;
            right = roomSizes.roomLength / 2 - (decor.position[0] + boundingX * decor.center[0]) * 1000;
        }
    }

    return {
        left: Math.round(Math.abs(left)),
        right: Math.round(Math.abs(right)),
        top: Math.round(top),
        bottom: Math.round(bottom),
    };
}

export default calcRelativePaddings;
